import React from 'react'
import './LeaveSettings.css'
import { Button, Card, Checkbox, Col, Row, Switch, Table } from 'antd';
import { useNavigate } from "react-router-dom";
import { CheckCircleFilled, ClockCircleFilled } from '@ant-design/icons';
import { TiPencil } from "react-icons/ti";
import { MdDelete } from 'react-icons/md';
function LeaveSettings() {
    const navigate = useNavigate();
    const handlecompany = () => {
        navigate('/attendancesettings');
    }
    const addcompany = () => {
        navigate('/leavetypes');
    }
    const onChange = (e: CheckboxChangeEvent) => {
        console.log(`checked = ${e.target.checked}`);
      };
      const onChange1 = (e: CheckboxChangeEvent) => {
        console.log(`checked = ${e.target.checked}`);
      };
      const onChange2 = (e: CheckboxChangeEvent) => {
        console.log(`checked = ${e.target.checked}`);
      };
    const columns = [
        {
          title: 'Leave type',
          dataIndex: 'leavetype',
        },
        {
          title: <>Monthly<br /> Leaves</>,
          dataIndex: 'monthly',
        },
        {
          title: <>Monthly<br /> Carry over</>,
          dataIndex: 'carry',
        },
        {
          title: <>Max. Leave<br /> in a month</>,
          dataIndex: 'max',
        },
        {
          title: <>Yearly<br /> Carry over</>,
          dataIndex: 'yearly',
        }
    
    
    
      ];
      const data = [];
      for (let i = 0; i < 3; i++) {
        data.push({
          key: i,
          leavetype: 'Casual Leave',
          monthly: '2',
          carry: '2',
          max: '2',
          yearly: '2'
        });
      }
    return (
        <div className='flex flex-row'>
            <div className="set-left-back w-4/5 h-screen">
                <p className='set-add-lorem-titla'>Lorem Ipsum Company</p>
                <p className='set-add-name'>Mr. Bhaskar Sharma</p>
                <div className='set-car-con'>
                    <Card
                        className='set-car-back'
                        style={{
                            width: 200,
                            height: 80,
                            fontSize: '12px',
                            fontWeight: 'bold',
                            color: '#60626F',
                        }}
                    >
                        <p>Aadhar No.:3458709854864</p>
                        <p>Phone No.:3458709854864</p>
                        <p>Email:3458709854864</p>
                    </Card>
                </div>
                <div className='mt-5 set-sub-topic'>
                    <p className='set-comapny-topic'><ClockCircleFilled className='set-comany-icon1' />Add Other companies</p>
                    <p className='set-comapny-topic mt-1'><ClockCircleFilled className='set-comany-icon' />Company Address</p>
                    <p className='set-comapny-topic mt-1'><ClockCircleFilled className='set-comany-icon' />Office maps location</p>
                    <p className='set-comapny-topic mt-1'><CheckCircleFilled className='set-comany-icon1' />Department & Designation</p>
                    <p className='set-comapny-topic mt-1'><CheckCircleFilled className='set-comany-icon1' />Contractor</p>
                    <p className='set-comapny-topic mt-1'><CheckCircleFilled className='set-comany-icon1' />Leave type</p>
                    <p className='set-comapny-topic mt-1'><CheckCircleFilled className='set-comany-icon1' />Leave Setting</p>
                    <p className='set-comapny-topic mt-1'><CheckCircleFilled className='set-comany-icon1' />Attendance Setting</p>
                    <p className='set-comapny-topic mt-1'><CheckCircleFilled className='set-comany-icon1' />Derectory Setting</p>
                    <p className='set-comapny-topic mt-1'><CheckCircleFilled className='set-comany-icon1' />Add Staff</p>
                    <p className='set-comapny-topic mt-1'><CheckCircleFilled className='set-comany-icon1' />Department Heads</p>
                </div>
            </div>
            <div className="w-1/2  flex flex-col pl-5 pr-5">
                <div className=" mt-5 flex justify-between set-praavi-titel items-center">
                    <span className='set-company-logo mr-3'>P</span>
                    <span className='set-company-logo mr-3'>R</span>
                    <span className='set-company-logo mr-3'>A</span>
                    <span className='set-company-logo mr-3'>A</span>
                    <span className='set-company-logo mr-3'>V</span>
                    <span className='set-company-logo'>I</span>
                </div>
                <div className=" flex justify-between set-bui-title items-center">
                    <span className='set-add-bui mr-1'>B</span>
                    <span className='set-add-bui mr-1'>U</span>
                    <span className='set-add-bui mr-1'>S</span>
                    <span className='set-add-bui mr-1'>I</span>
                    <span className='set-add-bui mr-1'>N</span>
                    <span className='set-add-bui mr-1'>E</span>
                    <span className='set-add-bui mr-1'>S</span>
                    <span className='set-add-bui mr-1'>S</span>
                    <span className='set-add-bui mr-1'>O</span>
                    <span className='set-add-bui mr-1'>W</span>
                    <span className='set-add-bui mr-1'>N</span>
                    <span className='set-add-bui mr-1'>E</span>
                    <span className='set-add-bui mr-1'>R</span>
                </div>
                <div>
                    <p className='set-add-company'>Leave Settings</p>
                </div>
                <Row className='mt-3'>
                    <Col>
                        <span className='leave-set flex'>White collar staff leaves<TiPencil className='pen-set' /><MdDelete className='del-set' /></span>
                    </Col>
                    <Col>
                        <span className='leave-set ml-5 flex'>Blue collar leaves<TiPencil className='pen-set' /><MdDelete className='del-set' /></span>
                    </Col>
                    <Col>
                        <span className='leave-set ml-5 flex'>Lorem rules set<TiPencil className='pen-set' /><MdDelete className='del-set' /></span>
                    </Col>
                </Row>
                <div>
                    <p className='contra-add-plush'>+Add More</p>
                </div>

                <div className='set-newrule-back'>
                    <p className='set-rule'>New Rule</p>
                    <div>
                        <span className='set-first-rule'>Leave rule set name</span>
                        <span className='set-first-des'>Description</span>

                    </div>
                    <div className='mt-2'>
                        <span className='set-earn'>Earn Leave</span>
                        <Switch size="small" className='ml-3' defaultChecked />
                    </div>
                    <div className='set-org-table mt-2'>
                        <Table columns={columns} dataSource={data} pagination={false} />
                    </div>
                    <p className='set-rule mt-2'>+Add More Leave Types</p>
                </div>

                <p className='set-earned'>Earned Leave setting</p>
            <div className='set-enable-back'>
              <Checkbox className='set-chek-collar' onChange={onChange}>Enabled Earned Leaves</Checkbox>
              <div className='set-check-back mt-2'>
                <p className='set-case-con'>In case the employee is Present on holiday/ WO, employee has the following option</p>
                <div className='set-apply-back'>
                  <Checkbox className='set-chek-collar' onChange={onChange1}>Apply for compensatory off/ earned leave on that day</Checkbox>
                  <div>
                    <Checkbox className='set-chek-collar' onChange={onChange2}>Apply for extra pay</Checkbox>
                  </div>
                </div>
                <p className='set-last-collar-con mt-2'>if both are selected, the employee will be able to choose either of the two option. in case nothing is selected,system will default to payment for extra day</p>
              </div>
            </div>
                <div className='flex contra-buttons mt-5'>
                    <Button className='contra-company-add-back' onClick={addcompany}>Back</Button>
                    <Button className='contra-company-add-next' onClick={handlecompany}>Next</Button>

                </div>
            </div>

        </div>
    )
}

export default LeaveSettings